import { PresetType } from "@/components/ui-v2/AspectRatio";
import { AspectRatio, AspectRatioType } from "@/types";

// Function to calculate GCD (Greatest Common Divisor)
const gcd = (a: number, b: number): number => {
  return b === 0 ? a : gcd(b, a % b);
};

// Function to get simplified aspect ratio as string (e.g., "16:9", "1:1")
export const getAspectRatioString = (width: number, height: number): string => {
  if (width === 0 && height === 0) return "0:0";

  const divisor = gcd(width, height);
  const simplifiedWidth = width / divisor;
  const simplifiedHeight = height / divisor;
  return `${simplifiedWidth}:${simplifiedHeight}`;
};

// Hacky solution to have PresetType and AspectRatioType match up
// TODO: Review all this but the problem we have is that 768:1360 is mapped to 9:16 instead of 85:48
const standardAspectRatios = [
  {
    ratio: 1 / 1,
    type: "SQUARE" as AspectRatioType,
    width: 1,
    height: 1,
  },
  {
    ratio: 4 / 3,
    type: "LANDSCAPE_4_3" as AspectRatioType,
    width: 4,
    height: 3,
  },
  {
    ratio: 16 / 9,
    type: "LANDSCAPE_16_9" as AspectRatioType,
    width: 16,
    height: 9,
  },
  {
    ratio: 21 / 9,
    type: "LANDSCAPE_21_9" as AspectRatioType,
    width: 21,
    height: 9,
  },
  {
    ratio: 3 / 2,
    type: "LANDSCAPE_3_2" as AspectRatioType,
    width: 3,
    height: 2,
  },
  {
    ratio: 5 / 4,
    type: "LANDSCAPE_5_4" as AspectRatioType,
    width: 5,
    height: 4,
  },
  {
    ratio: 9 / 16,
    type: "PORTRAIT_9_16" as AspectRatioType,
    width: 9,
    height: 16,
  },
  {
    ratio: 9 / 21,
    type: "PORTRAIT_9_21" as AspectRatioType,
    width: 9,
    height: 21,
  },
  {
    ratio: 2 / 3,
    type: "PORTRAIT_2_3" as AspectRatioType,
    width: 2,
    height: 3,
  },
  {
    ratio: 3 / 4,
    type: "PORTRAIT_3_4" as AspectRatioType,
    width: 3,
    height: 4,
  },
  {
    ratio: 4 / 5,
    type: "PORTRAIT_4_5" as AspectRatioType,
    width: 4,
    height: 5,
  },
];

export const mapPresetTypeToAspectRatio = (presetType: PresetType) => {
  const [width, height] = presetType.dimensions;

  // Calculate the actual aspect ratio
  const actualRatio = width / height;

  // Find the closest standard aspect ratio
  let closestMatch = standardAspectRatios[0];
  let smallestDifference = Math.abs(actualRatio - closestMatch.ratio);

  for (const standard of standardAspectRatios) {
    const difference = Math.abs(actualRatio - standard.ratio);
    if (difference < smallestDifference) {
      smallestDifference = difference;
      closestMatch = standard;
    }
  }

  return {
    type: closestMatch.type,
    width: closestMatch.width,
    height: closestMatch.height,
  } satisfies AspectRatio;
};
